/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Validation_Email_RequiredInputs */

const en_users_validation_email_required = /** @type {(inputs: Users_Validation_Email_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email is required`)
};

const pt_br2_users_validation_email_required = /** @type {(inputs: Users_Validation_Email_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail é obrigatório`)
};

/**
* | output |
* | --- |
* | "Email is required" |
*
* @param {Users_Validation_Email_RequiredInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_validation_email_required = /** @type {((inputs?: Users_Validation_Email_RequiredInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Validation_Email_RequiredInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_validation_email_required(inputs)
	return pt_br2_users_validation_email_required(inputs)
});